export default "__VITE_ASSET__Dwsna02I__"